export const mapImages = {
	arrow: 'mapIcons/arrow-small.png',
}
export const mapVectorImages = {
	marker: 'mapIcons/marker.svg',
}
